var __default__ = {root:'m_e615b15f',section:'m_599a2148'};
export default __default__;